/**
 * Admin — Objectifs de rénovation (classement des gestes par objectif).
 *
 * Page portée dans la SPA (design du site) : sert /admin/renovation-objectives
 * — remplace l'ex-île astro blanche du même nom.
 */
import { Link } from "react-router-dom";
import { Layout } from "@/components/Layout";
import AdminRenovationObjectives from "@/components/admin/AdminRenovationObjectives";

export default function AdminRenovationObjectivesPage() {
  return (
    <Layout>
      <div className="mx-auto max-w-5xl px-6 py-12">
        <Link to="/admin" className="text-sm text-blue-900 underline">
          ← Admin
        </Link>
        <div className="mt-3">
          <AdminRenovationObjectives />
        </div>
      </div>
    </Layout>
  );
}
